import React, { useState } from "react";

export const CollapsibleJSON = ({ data, level = 0 }) => {
  const [collapsed, setCollapsed] = useState({});

  const toggleCollapse = (key) => {
    setCollapsed((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const renderValue = (value, key, index) => {
    const uniqueKey = `${key}-${index}-${level}`;

    if (value === null) {
      return <span style={{ color: "#999" }}>null</span>;
    }

    if (typeof value === "boolean") {
      return <span style={{ color: "#0066cc" }}>{value.toString()}</span>;
    }

    if (typeof value === "number") {
      return <span style={{ color: "#cc6600" }}>{value}</span>;
    }

    if (typeof value === "string") {
      return <span style={{ color: "#009900" }}>"{value}"</span>;
    }

    if (Array.isArray(value)) {
      const isCollapsed = collapsed[uniqueKey];
      return (
        <div>
          <span
            onClick={() => toggleCollapse(uniqueKey)}
            style={{
              cursor: "pointer",
              userSelect: "none",
              color: "#666",
              fontWeight: "bold",
            }}
          >
            {isCollapsed ? "▶" : "▼"} [{value.length} items]
          </span>
          {!isCollapsed && (
            <div
              style={{
                marginLeft: "20px",
                paddingLeft: "10px",
                borderLeft: "1px solid #ddd",
              }}
            >
              {value.map((item, idx) => (
                <div key={idx} style={{ margin: "5px 0" }}>
                  <span style={{ color: "#666", marginRight: "5px" }}>
                    [{idx}]:
                  </span>
                  {renderValue(item, `${key}-${idx}`, idx)}
                </div>
              ))}
            </div>
          )}
        </div>
      );
    }

    if (typeof value === "object" && value != null) {
      const keys = Object.keys(value);
      const isCollapsed = collapsed[uniqueKey];

      return (
        <div
          style={{
            height: "400px", // Set your desired fixed height
            maxHeight: "400px", // Ensures it doesn't exceed this height
            overflow: "auto", // Shows scrollbars when needed>
          }}
        >
          <span
            onClick={() => toggleCollapse(uniqueKey)}
            style={{
              cursor: "pointer",
              userSelect: "none",
              color: "#666",
              fontWeight: "bold",
            }}
          >
            {isCollapsed ? "▶" : "▼"} {`{${keys.length} keys}`}
          </span>
          {!isCollapsed && (
            <div
              style={{
                marginLeft: "20px",
                paddingLeft: "10px",
                borderLeft: "1px solid #ddd",
              }}
            >
              {keys.map((objKey) => (
                <div key={objKey} style={{ margin: "5px 0" }}>
                  <span style={{ color: "#cc0000", marginRight: "5px" }}>
                    "{objKey}":
                  </span>
                  {renderValue(value[objKey], `${key}-${objKey}`, objKey)}
                </div>
              ))}
            </div>
          )}
        </div>
      );
    }

    return <span>{String(value)}</span>;
  };

  return (
    <div
      style={{
        backgroundColor: "#f8f9fa",
        border: "1px solid #dee2e6",
        borderRadius: "8px",
        padding: "16px",
        fontFamily: "Monaco, Consolas, monospace",
        fontSize: "14px",
        overflow: "auto",
        maxHeight: "500px",
        lineHeight: "1.6",
      }}
    >
      {renderValue(data, "root", 0)}
    </div>
  );
};
